import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useClient } from '@/clients/useClient';
import { loadLastProduct, resolveLandingRoute } from '@/clients/productPreference';

export const Route = createFileRoute('/')({
    component: IndexRedirect,
});

/**
 * Root landing. Users who may enter Network Explorer land there — it is the estate-wide home
 * for the Origin staff who hold the permission. Everyone else is redirected to the remembered
 * product (falling back to the first one the active client can use, then find-and-fix). Waits
 * for the client list to load so the remembered product can be checked against the client's
 * modules — avoiding landing on a product that would only show an upsell. Only the bare `/`
 * is affected: a deep link into a product is honoured as typed.
 */
function IndexRedirect() {
    const { selectedClient, isLoading, canViewNetworkExplorer } = useClient();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoading) return;
        if (canViewNetworkExplorer) {
            void navigate({ to: '/network-explorer', replace: true });
            return;
        }
        void navigate({ to: resolveLandingRoute(loadLastProduct(), selectedClient), replace: true });
    }, [isLoading, canViewNetworkExplorer, selectedClient, navigate]);

    return null;
}
